module.exports = __webpack_public_path__ + "static/media/cricketbd.1cac920c.jpeg";